<section class="default-padding margin--bottom-l margin--top-l">
  <div class="default-max-width default-text-spacing centered">
    <h2 class="headline-second">
      {{ data.title }}
    </h2>

    <div>
      <app-collapsible *ngFor="let faq of data.faqs" [title]="faq.question" [content]="faq.answer"></app-collapsible>
    </div>
  </div>
</section>
